import { getOriginationRiskValuesByOriginationRiskValuesId } from '@nemuru-eng/js-api-client';

import { OnboardingDetails } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';

interface UseRiskScore {
  loanId: string;
  onboardingDetails?: OnboardingDetails;
}

export const useRiskScore = ({ onboardingDetails }: UseRiskScore) => {
  const originationRiskValuesId =
    onboardingDetails && 'originationRiskValuesId' in onboardingDetails
      ? onboardingDetails?.originationRiskValuesId
      : undefined;

  if (!originationRiskValuesId) return;

  const { data: originationRiskValues } = useCache(getOriginationRiskValuesByOriginationRiskValuesId, {
    originationRiskValuesId,
  });

  return { originationRiskValues };
};
